import { create } from 'zustand';

type TeamspaceWelcomeModalState = {
  isNewUser: boolean;
  showTooltip: boolean;
  spaceId: null | string;
  reset: () => void;
  setSpaceId: (value: null | string) => void;
};

export const useTeamspaceWelcomeModal = create<TeamspaceWelcomeModalState>((set) => ({
  isNewUser: false,
  showTooltip: false,
  spaceId: null,
  reset: () => set({ isNewUser: true, showTooltip: true, spaceId: null }),
  setSpaceId: (value) => set({ isNewUser: true, spaceId: value }),
}));
